import React from 'react';
import { APP_STORE_URL, PLAY_STORE_URL } from './constants';
import { IconApple, IconGooglePlayMark } from './HomeRedesignIcons';
import { useHomeRedesignStrings } from './useHomeRedesignStrings';

export type StorePickerPopoverAlign = 'end' | 'center';
export type StorePickerPopoverPlacement = 'below' | 'above';

type StorePickerPopoverProps = {
  align: StorePickerPopoverAlign;
  placement?: StorePickerPopoverPlacement;
  onClose: () => void;
};

const linkClass =
  'flex items-center gap-2.5 rounded-xl px-2.5 py-2.5 font-jakarta text-[13px] font-semibold text-[#2a0f2a] transition-colors hover:bg-[#fcf7fa] hover:text-chisme-primary';

const StorePickerPopover: React.FC<StorePickerPopoverProps> = ({
  align,
  placement = 'below',
  onClose,
}) => {
  const p = useHomeRedesignStrings().storePicker;

  const positionClass =
    placement === 'above'
      ? align === 'center'
        ? 'bottom-full left-1/2 mb-2 -translate-x-1/2'
        : 'bottom-full right-0 mb-2'
      : align === 'center'
        ? 'left-1/2 top-full mt-2.5 -translate-x-1/2'
        : 'right-0 top-full mt-2';

  return (
    <div
      role="menu"
      aria-label={p.subtitle}
      className={`absolute z-[70] w-[min(17.5rem,calc(100vw-1.25rem))] ${positionClass} rounded-[20px] border border-[rgba(74,33,71,0.1)] bg-[rgba(255,255,255,0.92)] p-3.5 shadow-[0px_12px_30px_0px_rgba(74,33,71,0.14)] backdrop-blur-[7px]`}
    >
      <button
        type="button"
        onClick={onClose}
        className="absolute right-2 top-2 rounded-md px-1.5 py-0.5 font-jakarta text-[15px] leading-none text-[#5a3158]/40 transition-colors hover:bg-[#fcf7fa] hover:text-[#2a0f2a]"
        aria-label={p.closeAria}
      >
        ×
      </button>

      <p className="pr-7 font-instrument text-[1.125rem] italic leading-snug tracking-[-0.01em] text-[#2a0f2a]">
        {p.title}
      </p>
      <p className="mt-0.5 font-jakarta text-[11px] leading-relaxed text-[#5a3158]/85">{p.subtitle}</p>

      <div className="mt-3 space-y-0.5 border-t border-[rgba(74,33,71,0.08)] pt-2">
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          role="menuitem"
          className={linkClass}
          onClick={onClose}
        >
          <IconApple className="size-[18px] shrink-0 text-[#2a0f2a]" />
          <span>{p.appleLabel}</span>
        </a>
        <a
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          role="menuitem"
          className={linkClass}
          onClick={onClose}
        >
          <IconGooglePlayMark className="size-[18px] shrink-0" />
          <span>{p.googleLabel}</span>
        </a>
      </div>
    </div>
  );
};

export default StorePickerPopover;
